import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { StatusBar, DeviceInfo } from 'qunar-react-native';
import { Provider, observer } from 'mobx-react/native';
import { listSource } from './staticDataSource/index';
import rootStore from '../../stores/selectCountry';
import SizeUtil from '../../utils/SizeUtil';
import CitySearchBar from './CitySearchBar';
import IndexList from './ListView/IndexList';
import SearchResult from './SearchResult/index';
import Alert from '../../components/Alert';

const styles = StyleSheet.create({
    container: {
        position: 'relative',
        flex: 1
    },
    backBtn: {
        marginLeft: 5,
        fontFamily: 'cmn_order_rn',
        fontSize: 20,
        color: '#333'
    }
});

@observer
class SelectCountry extends QView<any> {
    public static routerPlugin = {
        isShow: true,
        backgroundColor: 'white',
        color: 'black',
        buttonWidth: 60,
        statusBarBackgroundColor: 'white',
        height: 44,
        activeOpacity: 0.6,
        title: '选择国家或地区',
        leftButtonText: <Text style={styles.backBtn}>&#xf07d;</Text>
    };

    public componentDidMount() {
        if (DeviceInfo.isIOS || (!DeviceInfo.isIOS && Number(DeviceInfo.vid) > 60001224)) {
            StatusBar.setStyle(
                'dark',
                () => {},
                () => {}
            );
        }
    }

    public render() {
        return (
            <Provider {...rootStore}>
                <View style={{ flex: 1 }}>
                    <CitySearchBar />
                    {
                        !DeviceInfo.isMini
                        &&
                        <Alert
                            isVisible={rootStore.searchBar.visAlert}
                            onCancel={() => rootStore.searchBar.changeVisAlert(false)}
                            onOk={() => rootStore.searchBar.changeVisAlert(false)}
                            title="网络好像不是很给力"
                            btnText="知道了"
                        />
                    }
                    <View style={styles.container}>
                        <IndexList
                            isInland
                            // dataLists={listSource}
                            // hotCityDataListHeight={20}
                            absoluteStartY={SizeUtil.getSize(44)}
                        />
                        {rootStore.searchBar.isSearchPage && <SearchResult />}
                    </View>
                </View>
            </Provider>
        );
    }
}

export default SelectCountry;
